import css from "styled-jsx/css";
import Colors from "/styles/colors";
import { ZERO, TOP_LAYER } from "constants/z-index";
import { WHITE_COLOR_NAME } from "styles/color-consts";

export const componentStyles = css.global`
  .universe-star-tag-component {
    display: flex;
    flex-direction: column;
    align-items: center;
    position: relative;
    justify-content: center;
    z-index: ${TOP_LAYER};

    .background-circle {
      transition: opacity 100ms ease-in-out;
      position: absolute;
      width: 80px;
      height: 80px;
      border-radius: 50%;
      background-color: currentColor;
      opacity: 25%;
      filter: blur(30px);
      z-index: ${ZERO};
    }

    .star-image {
      .star-icon {
        width: 24px;
      }
    }
    .star-text {
      transition: opacity 100ms ease-in-out;
      text-align: center;
      max-width: 100px;
      font-size: 14px;
      color: ${Colors[WHITE_COLOR_NAME]};
      cursor: default;
      opacity: 75%;
    }

    &:hover {
      .background-circle {
        opacity: 40%;
      }
      .star-text {
        opacity: 100%;
      }
    }
  }
`;
